import React from 'react';
import {InnerContainer, MainContainer} from '../../HOC/Layout/Style';
import {
    LLMInteractionCategoriesEditor
} from "./Components/LLMInteractionCategoriesEditor/LLMInteractionCategoriesEditor";

const LLMInteractionCategoriesContainer = () => {
    return (
        <MainContainer>
            <InnerContainer>
                <LLMInteractionCategoriesEditor/>
            </InnerContainer>
        </MainContainer>
    );
};

export default LLMInteractionCategoriesContainer;